import { Layers, TrendingUp, LayoutDashboard, Compass } from "lucide-react";
import { SectionHead, Reveal } from "./shared";
import { DashboardMockup } from "./DashboardMockup";

const FEATURES = [
  { icon: Layers, title: "Gestão por lotes", desc: "Cada lote é uma unidade econômica própria, com custo, margem e resultado rastreáveis do início ao fim." },
  { icon: TrendingUp, title: "Margem projetada e realizada", desc: "A margem se atualiza continuamente a cada remarcação e venda — sem esperar o fechamento do mês." },
  { icon: LayoutDashboard, title: "Visão completa da operação", desc: "Custos, margem e faturamento conectados em uma única leitura gerencial, sem planilhas paralelas." },
  { icon: Compass, title: "Decisão baseada em indicadores", desc: "Compra, preço, desconto e meta deixam de ser intuição e passam a ser decisão fundamentada." },
];

export const About = () => (
  <section id="plataforma" data-testid="about-section" className="relative bg-tria-navy/50 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="A plataforma"
        testId="about-head"
        title={<>A TRIA é uma plataforma de gestão gerencial <span className="text-gradient-blue">baseada em método</span></>}
        sub="Um método prático de gestão transformado em sistema: relacional, rastreável e auditável. Não é só um software — é uma forma de enxergar o negócio."
      />

      <div className="grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-16">
        <div className="grid gap-4 sm:grid-cols-2">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08}>
              <div
                data-testid={`about-card-${i + 1}`}
                className="group h-full rounded-2xl border border-white/[0.07] bg-white/[0.02] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-tria-sky/30 hover:bg-tria-sky/[0.04]"
              >
                <span className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-tria-vivid/25 to-tria-sky/10 text-tria-sky transition-transform duration-300 group-hover:scale-110">
                  <f.icon className="h-5 w-5" />
                </span>
                <h3 className="font-display text-[17px] font-semibold text-white">{f.title}</h3>
                <p className="mt-2.5 text-[13.5px] leading-relaxed text-tria-mist">{f.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="absolute -inset-8 -z-10 rounded-[32px] bg-tria-vivid/15 blur-3xl" />
            <DashboardMockup compact />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
